/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Delete_Project_SuccessInputs */



/**
* | output |
* | --- |
* | "Project deleted successfully!" |
*
* @param {Projects_Delete_Project_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_delete_project_success = /** @type {((inputs?: Projects_Delete_Project_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Delete_Project_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt erfolgreich gelöscht!")
	return /** @type {LocalizedString} */ ("Project deleted successfully!")
});